import { Skeleton, SkeletonText } from '@dev-spendesk/grapes';
import React from 'react';

export const BudgetOverviewLoader = () => {
  return (
    <div className="box flex w-full flex-col">
      <SkeletonText className="mb-16" width="137px" size="xl" />
      <Skeleton className="mb-16" width="239px" height="26px" />
      <SkeletonText className="mb-16 max-w-full" width="445px" size="l" />
      <div className="flex gap-8">
        <SkeletonText width="106px" size="xl" />
        <SkeletonText width="106px" size="xl" />
      </div>
    </div>
  );
};
